import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

export function NewHeroSection() {
  const { t, localizedPath } = useLanguage();

  return (
    <section className="min-h-screen flex flex-col justify-center px-6 pt-20">
      <div className="max-w-[1400px] mx-auto w-full">
        <div>
          <h1 className="font-display text-display-xl max-w-[14ch]">
            {t("hero.headline")}
          </h1>
          <p className="mt-6 text-body-lg italic text-foreground/80">
            {t("hero.middle")}
          </p>
          <p className="mt-4 text-body-lg italic text-foreground/80">
            {t("hero.subline")}
          </p>
          <p className="mt-4 text-body-lg italic text-foreground/80 max-w-xl">
            {t("hero.seo")}
          </p>
          <Link
            to={localizedPath("/contact")}
            className="inline-flex items-center mt-10 px-8 py-3.5 rounded-full bg-accent text-accent-foreground text-sm font-medium uppercase tracking-wider hover:opacity-90 transition-opacity"
          >
            {t("hero.cta")} →
          </Link>
        </div>
      </div>
    </section>
  );
}
